import { render, staticRenderFns } from "./CommunityQnaCreate.vue?vue&type=template&id=2fc8d3a8&"
import script from "./CommunityQnaCreate.vue?vue&type=script&lang=js&"
export * from "./CommunityQnaCreate.vue?vue&type=script&lang=js&"
import style0 from "./CommunityQnaCreate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports